import React, { useEffect, useState } from 'react';
import styles from "../MetaField.module.scss";
import { CustomDropdown } from 'components/shared/customDropdown';
import { TextField } from '@mui/material';
import HighlightOffIcon from '@mui/icons-material/HighlightOff';
import { AssignToFilterContainer } from 'components/pages/tasks/components/AssignToFilterContainer';
import { useDispatch, useSelector } from 'react-redux';
import { setDroppedItems } from '@redux/slices/triggerSlice';
import { setPublish } from '@redux/slices/globalSlice';

const options = [
    { label: "is", value: "is" },
    // { label: "contains", value: "contains" },
];

const SubmittedBy = ({ item }) => {
    const [localOptions, setLocalOptions] = useState({
        label: "Submitted By", options: item?.operator || "is",
        value: item?.value || [],
        valueLabel: item?.valueLabel || "",
    });


    const { triggerDroppedList } = useSelector((state) => state?.trigger);
    const dispatch = useDispatch();


    const handleDelete = () => {
        const filteredDroppedItems = triggerDroppedList?.filter((e) => e?.id !== item?.id);
        dispatch(setDroppedItems(filteredDroppedItems));
        dispatch(setPublish(true))
    };

    const handleChange = (name, value, valueLabel) => {
        // if(value===undefined) return
        setLocalOptions((prev) => {
            let updatedOptions;

            if (name === "value") {
                // Ensure value is always an array
                updatedOptions = { ...prev, [name]: Array.isArray(value) ? value : [value], valueLabel: valueLabel || "" };
            } else {
                updatedOptions = { ...prev, [name]: value };
            }

            return updatedOptions;
        });
    };

    useEffect(() => {
        const updatedTriggerList = triggerDroppedList?.map((e) => {
            if (e?.id === item?.id) {
                return {
                    ...e,
                    optionLabel: item?.label || "Submittetd by",
                    valueLabel: localOptions?.valueLabel || "",
                    value: localOptions?.value || [],
                    trigger: { ...localOptions },
                };
            }
            return e;
        });

        dispatch(setDroppedItems(updatedTriggerList));
    }, [localOptions]);

    return (
        <>
            <div className={styles?.metaContainer}>
                <div className={styles?.field}>
                    <TextField  value={"Submitted By"} disabled={true} />
                    {/* <CustomDropdown
                        options={options}
                        width="200px"
                        onChange={(e) => handleChange(e?.target?.name, e?.target?.value)}
                        name="options"
                        value={localOptions?.options}
                    /> */}
                    <TextField inputProps={{
        style: { width: "200px" },
      }} value={"is"} disabled={true} />

                    {localOptions?.options === "contains" ? (
                     <TextField
                            name="value"
                            onChange={(e) => handleChange(e?.target?.name, e?.target?.value)}
                        />
                    ) :
                        (
                            <AssignToFilterContainer
                                width="170px"
                                label={false}
                                height={"35px"}
                                defaultValue={{
                                    label: localOptions?.valueLabel || "",
                                    value: localOptions?.value || ""
                                }}
                                customStyles={{
                                    marginTop: "0px !important",
                                    "& .MuiOutlinedInput-root.MuiInputBase-sizeSmall": {
                                        paddingBottom: "3px",
                                        paddingTop: "4.5px"
                                    }
                                }}
                                placeholder="Enter a Submitter"
                                isDefSelect={false}
                                onSelectedUser={(newValue) =>
                                    handleChange("value", newValue?.value, newValue?.label)
                                }
                            />
                        )
                    }
                </div>

                <div
                    style={{ display: "flex", alignItems: "center", cursor: "pointer" }}
                    onClick={handleDelete}
                >
                    <HighlightOffIcon />
                </div>
            </div>
        </>
    );
};

export default SubmittedBy;
